export const BUILD_FOR_SITECORE = false;
export const LOGIN_ROUTE = '/login';
export const ROOT_ROUTE = '/';

// So here's a trick.  We want to be able to add this react app to whatever
// Sitecore page we want and have the URLs work out.  For instance, if we
// put the app on /depts/heart/appointments, that path needs to be the base,
// while the subpages appear to be in the "folder" -
// e.g. /depts/heart/appointments/contact-info

export const pages = {
  WHAT_TO_EXPECT: "what-to-expect",
  WHO_FOR: "patient",
  RECEIVED_CARE: "patient-status",
  NEW_PATIENT_INFO: "new-patient-info",
  NEW_PATIENT_ADDRESS: "new-patient-contact-info",
  EXISTING_PATIENT_INFO: "established-patient-info",
  CONTACT_INFO: "contact-info",
  APPOINTMENT_INFO1: "appointment-info",
  APPOINTMENT_INFO2: "appointment-services",
  APPOINTMENT_PREFERENCES: "appointment-area",
  APPOINTMENT_INFO_PROVIDER: "appointment-provider",
  APPOINTMENT_INFO_DAY_TIME: "appointment-day-time",
  PAYMENT_METHOD: "payment-method",
  INSURANCE: "insurance",
  POLICY_HOLDER: "policy-holder",
  BILLING: "billing",
  BILLING_ADDRESS: "billing-address",
  OUT_OF_POCKET: "out-of-pocket",
  REVIEW: "review",
  PFA_APPOINTMENT: "pfa-appointment",
  THANK_YOU_PFA_APPT: "thank-you-pfa-appointment",
  THANK_YOU_PFA: "thank-you-pfa",
  THANK_YOU_INSURANCE: "thank-you-insurance",
  ERROR_REVIEW: "error-review"
};

let pathBase = window.location.pathname;
let keys = Object.keys(pages);
keys.forEach(key => {
  if (pathBase.endsWith(pages[key])) {
    pathBase = pathBase.substring(0, pathBase.lastIndexOf("/"));
  }
});
if (pathBase === '/') {
  pathBase = "/root";
}

export const WEB_APPOINTMENT_ROOT = pathBase;  // includes a leading slash
export const WEB_APPOINTMENT_ROOT_SLASH = WEB_APPOINTMENT_ROOT + "/";
export const WEB_APPOINTMENT_WHAT_TO_EXPECT_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.WHAT_TO_EXPECT;
export const WEB_APPOINTMENT_WHO_FOR_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.WHO_FOR;
export const WEB_APPOINTMENT_RECEIVED_CARE_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.RECEIVED_CARE;
export const WEB_APPOINTMENT_NEW_PATIENT_INFO_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.NEW_PATIENT_INFO;
export const WEB_APPOINTMENT_NEW_PATIENT_ADDRESS_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.NEW_PATIENT_ADDRESS;
export const WEB_APPOINTMENT_EXISTING_PATIENT_INFO_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.EXISTING_PATIENT_INFO;
export const WEB_APPOINTMENT_CONTACT_INFO_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.CONTACT_INFO;
export const WEB_APPOINTMENT_APPOINTMENT_INFO1_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.APPOINTMENT_INFO1;
export const WEB_APPOINTMENT_APPOINTMENT_INFO2_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.APPOINTMENT_INFO2;
export const WEB_APPOINTMENT_APPOINTMENT_PREFERENCES_PAGE = WEB_APPOINTMENT_ROOT_SLASH + pages.APPOINTMENT_PREFERENCES;
export const WEB_APPOINTMENT_APPOINTMENT_INFO_PROVIDER = WEB_APPOINTMENT_ROOT_SLASH + pages.APPOINTMENT_INFO_PROVIDER;
export const WEB_APPOINTMENT_APPOINTMENT_INFO_DAY_TIME = WEB_APPOINTMENT_ROOT_SLASH + pages.APPOINTMENT_INFO_DAY_TIME;
export const WEB_APPOINTMENT_PAYMENT_METHOD = WEB_APPOINTMENT_ROOT_SLASH + pages.PAYMENT_METHOD;
export const WEB_APPOINTMENT_INSURANCE = WEB_APPOINTMENT_ROOT_SLASH + pages.INSURANCE;
export const WEB_APPOINTMENT_POLICY_HOLDER = WEB_APPOINTMENT_ROOT_SLASH + pages.POLICY_HOLDER;
export const WEB_APPOINTMENT_BILLING = WEB_APPOINTMENT_ROOT_SLASH + pages.BILLING;
export const WEB_APPOINTMENT_BILLING_ADDRESS = WEB_APPOINTMENT_ROOT_SLASH + pages.BILLING_ADDRESS;
export const WEB_APPOINTMENT_OUT_OF_POCKET = WEB_APPOINTMENT_ROOT_SLASH + pages.OUT_OF_POCKET;
export const WEB_APPOINTMENT_REVIEW = WEB_APPOINTMENT_ROOT_SLASH + pages.REVIEW;
export const WEB_APPOINTMENT_PFA_APPOINTMENT = WEB_APPOINTMENT_ROOT_SLASH + pages.PFA_APPOINTMENT;
export const WEB_APPOINTMENT_THANK_YOU_PFA_APPT = WEB_APPOINTMENT_ROOT_SLASH + pages.THANK_YOU_PFA_APPT;
export const WEB_APPOINTMENT_THANK_YOU_PFA = WEB_APPOINTMENT_ROOT_SLASH + pages.THANK_YOU_PFA;
export const WEB_APPOINTMENT_THANK_YOU_INSURANCE = WEB_APPOINTMENT_ROOT_SLASH + pages.THANK_YOU_INSURANCE;
export const WEB_APPOINTMENT_ERROR_REVIEW = WEB_APPOINTMENT_ROOT_SLASH + pages.ERROR_REVIEW;

export const AppDataForPath = [
  { pathPattern: WEB_APPOINTMENT_ROOT, appName: "Web Appointment Form"},
];